<div class="pricing-view">
  <div class="pricing-cards">
    <app-pricing-cards [prices]="prices" (moreClick)="onMoreClick($event)"
      (togglePlan)="togglePlan($event)"></app-pricing-cards>
  </div>
</div>